/**
 * Trạng thái phân tích CV.
 */
export var AnalysisStatus;
(function (AnalysisStatus) {
    AnalysisStatus["PENDING"] = "PENDING";
    AnalysisStatus["PROCESSING"] = "PROCESSING";
    AnalysisStatus["COMPLETED"] = "COMPLETED";
    AnalysisStatus["FAILED"] = "FAILED";
})(AnalysisStatus || (AnalysisStatus = {}));
/**
 * Mức độ phù hợp giữa CV và Job Description.
 */
export var FitLevel;
(function (FitLevel) {
    FitLevel["STRONG"] = "STRONG";
    FitLevel["MODERATE"] = "MODERATE";
    FitLevel["NEEDS_IMPROVEMENT"] = "NEEDS_IMPROVEMENT";
})(FitLevel || (FitLevel = {}));
/**
 * Loại tài liệu được AI tạo.
 */
export var GeneratedDocumentType;
(function (GeneratedDocumentType) {
    GeneratedDocumentType["COVER_LETTER"] = "COVER_LETTER";
    GeneratedDocumentType["REWRITTEN_SUMMARY"] = "REWRITTEN_SUMMARY";
    GeneratedDocumentType["REWRITTEN_EXPERIENCE"] = "REWRITTEN_EXPERIENCE";
})(GeneratedDocumentType || (GeneratedDocumentType = {}));
/**
 * Vai trò trong cuộc hội thoại chat.
 */
export var ChatRole;
(function (ChatRole) {
    ChatRole["USER"] = "USER";
    ChatRole["ASSISTANT"] = "ASSISTANT";
})(ChatRole || (ChatRole = {}));
/**
 * Phong cách viết lại nội dung CV.
 */
export var RewriteStyle;
(function (RewriteStyle) {
    RewriteStyle["PROFESSIONAL"] = "PROFESSIONAL";
    RewriteStyle["CONCISE"] = "CONCISE";
    RewriteStyle["ACHIEVEMENT_FOCUSED"] = "ACHIEVEMENT_FOCUSED";
    RewriteStyle["JOB_OPTIMIZED"] = "JOB_OPTIMIZED";
    RewriteStyle["BULLET_POINTS"] = "BULLET_POINTS";
    RewriteStyle["QUANTIFIED"] = "QUANTIFIED";
})(RewriteStyle || (RewriteStyle = {}));
//# sourceMappingURL=enums.js.map